import React from "react";
import TiptapEditor from "../editor/TipTapEditor";

const TextRenderer = ({ content }) => {
  return <TiptapEditor content={content} editable={false} />;
};

export default TextRenderer;
